import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Mail, Phone, MapPin, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold text-white mb-4">
              <span className="text-green-500">VD Storage</span>
              <span className="text-white"> Bells</span>
            </div>
            <p className="text-gray-400 mb-4">
              Secure storage for boats, RVs, and business equipment in Bells, Texas.
              Located on Highway 82, minutes from Lake Texoma and Bois d'Arc Lake.
            </p>
            <div className="flex items-center space-x-2 mb-4">
              <MessageCircle className="h-5 w-5 text-green-500" />
              <span className="text-sm text-gray-400">AI Assistant Available 24/7</span>
            </div>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-green-500 transition-colors" aria-label="Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-green-500 transition-colors" aria-label="Twitter">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-green-500 transition-colors" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-green-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/boat-rv-parking-bells" className="hover:text-green-500 transition-colors">
                  Boat & RV Parking
                </Link>
              </li>
              <li>
                <Link to="/commercial-yard-storage-bells" className="hover:text-green-500 transition-colors">
                  Commercial Yard
                </Link>
              </li>
              <li>
                <Link to="/storage-sizes" className="hover:text-green-500 transition-colors">
                  Size Guide
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-green-500 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/boat-rv-storage-bells" className="hover:text-green-500 transition-colors">
                  Boat & RV Storage
                </Link>
              </li>
              <li>
                <Link to="/business-storage-bells" className="hover:text-green-500 transition-colors">
                  Business Storage
                </Link>
              </li>
              <li>
                <Link to="/tips-rules" className="hover:text-green-500 transition-colors">
                  Tips & Rules
                </Link>
              </li>
              <li>
                <Link to="/tenant-protection" className="hover:text-green-500 transition-colors">
                  Tenant Protection
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
                <span>5346 Hwy 82<br />Bells, TX 75414</span>
              </li>
              <li className="flex items-start">
                <Phone className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
                <a
                  href="tel:9036487100"
                  onClick={() => {
                    if (window.gtag) {
                      window.gtag('event', 'conversion_intent', {
                        'event_category': 'lead',
                        'event_label': 'footer_phone_call',
                        'facility_name': 'VD Storage Bells'
                      });
                    }
                  }}
                  className="hover:text-green-500 transition-colors"
                >
                  903-648-7100
                </a>
              </li>
              <li className="flex items-start">
                <Mail className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
                <span>vandd.bells@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} VD Storage Bells. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;